import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgMoneyWallet = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M19.4286 16.5714V18.8572C19.4286 19.1603 19.3082 19.451 19.0939 19.6653C18.8795 19.8796 18.5888 20 18.2857 20H5.14287C4.68822 20 4.25218 19.8194 3.93069 19.4979C3.6092 19.1764 3.42859 18.7404 3.42859 18.2857V5.7143C3.42859 5.25964 3.6092 4.82361 3.93069 4.50212C4.25218 4.18063 4.68822 4.00002 5.14287 4.00002H17.1429C17.446 4.00002 17.7367 4.12042 17.951 4.33475C18.1653 4.54908 18.2857 4.83977 18.2857 5.14287V6.85716"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.4285 16.5714C19.7316 16.5714 20.0223 16.451 20.2366 16.2367C20.451 16.0224 20.5714 15.7317 20.5714 15.4286V12C20.5714 11.6969 20.451 11.4062 20.2366 11.1919C20.0223 10.9776 19.7316 10.8572 19.4285 10.8572H16.5714C15.8136 10.8572 15.0869 11.1582 14.5511 11.694C14.0153 12.2298 13.7142 12.9565 13.7142 13.7143C13.7142 14.4721 14.0153 15.1988 14.5511 15.7346C15.0869 16.2704 15.8136 16.5714 16.5714 16.5714H19.4285Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5715 13.4286C16.628 13.4286 16.6832 13.4453 16.7302 13.4767C16.7772 13.5081 16.8138 13.5528 16.8354 13.605C16.8571 13.6572 16.8627 13.7146 16.8517 13.77C16.8407 13.8255 16.8135 13.8764 16.7735 13.9163C16.7336 13.9563 16.6826 13.9835 16.6272 13.9945C16.5718 14.0056 16.5143 13.9999 16.4621 13.9783C16.4099 13.9566 16.3653 13.92 16.3339 13.873C16.3025 13.8261 16.2858 13.7708 16.2858 13.7143C16.2858 13.6385 16.3159 13.5659 16.3695 13.5123C16.423 13.4587 16.4957 13.4286 16.5715 13.4286Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.4285 10.8571V7.99999C19.4285 7.69689 19.3081 7.4062 19.0938 7.19187C18.8795 6.97754 18.5888 6.85714 18.2857 6.85714H7.1428C6.89474 6.8688 6.64832 6.81119 6.43114 6.69076C6.21395 6.57033 6.03458 6.39182 5.91309 6.17523"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgMoneyWallet.displayName = 'SvgMoneyWallet';
export default SvgMoneyWallet;
